import { GET_ALL_ADMISSION_FORM_LIST } from "../actions/types";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_ADMISSION_FORM_LIST:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/getAllAdmissionFormList.js